import request from '@/utils/httpRequest'

export default {
  save: function (inputForm) {
    return request({
      url: '/cecunmsetmealpositionproject/cecUnmSetMealPositionProject/save',
      method: 'post',
      data: inputForm
    })
  },

  savePtProjectIds: function (inputForm) {
    return request({
      url: '/cecunmsetmealpositionproject/cecUnmSetMealPositionProject/savePtProjectIds',
      method: 'post',
      data: inputForm
    })
  },

  delete: function (ids) {
    return request({
      url: '/cecunmsetmealpositionproject/cecUnmSetMealPositionProject/delete',
      method: 'delete',
      params: {ids: ids}
    })
  },

  queryById: function (id) {
    return request({
      url: '/cecunmsetmealpositionproject/cecUnmSetMealPositionProject/queryById',
      method: 'get',
      params: {id: id}
    })
  },

  list: function (params) {
    return request({
      url: '/cecunmsetmealpositionproject/cecUnmSetMealPositionProject/list',
      method: 'get',
      params: params
    })
  },
  getAllSelectIds: function (params) {
    return request({
      url: '/cecunmsetmealpositionproject/cecUnmSetMealPositionProject/getAllSelectIds',
      method: 'get',
      params: params
    })
  },
  exportTemplate: function () {
    return request({
      url: '/cecunmsetmealpositionproject/cecUnmSetMealPositionProject/import/template',
      method: 'get',
      responseType: 'blob'
    })
  },

  exportExcel: function (params) {
    return request({
      url: '/cecunmsetmealpositionproject/cecUnmSetMealPositionProject/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    })
  },

  importExcel: function (data) {
    return request({
      url: '/cecunmsetmealpositionproject/cecUnmSetMealPositionProject/import',
      method: 'post',
      data: data
    })
  }
}
